// extracted by mini-css-extract-plugin
export default {"container":"ZE-z","dimension":"_E-z","dimensionLabels":"aF-z"};